module.exports = __webpack_public_path__ + "img/1.2057a371.png";